import { typedFetch } from "@/lib/helpers";
import { getRefreshGuestyCredentialsUrl } from "./api-url.constants";
import { API_METHODS } from "@/services/API/shared";

export const refreshGuestyCredentials = async (
  integrationToken: string,
  userId?: string
): Promise<void> => {
  const response = await typedFetch(getRefreshGuestyCredentialsUrl(userId), {
    method: API_METHODS.POST,
    body: JSON.stringify({ integrationToken }),
  });

  if (!response.ok) {
    throw new Error("Failed to refresh Guesty credentials");
  }
};
